import {
    calcAccessorialsPerspective,
    calcSubtotalPerspective,
    isSelfBilled,
} from '@/components/Accounting/Invoice/utils';

// Determine which legs of the order have an assigned carrier. Each leg has a carrier_id
// FK on the order; presence of the FK = the leg exists for billing purposes. For each
// leg present, render both shipper-side and carrier-side rate perspectives.
export const getActivePerspectives = (order) => {
    const result = [];
    if (order?.carrier_id) result.push('shipper', 'carrier');
    if (order?.middle_mile_carrier_id) result.push('mm_shipper', 'mm_carrier');
    if (order?.warehouse_carrier_id) result.push('wh_shipper', 'wh_carrier');
    if (order?.contractor_id) result.push('contractor');
    return result;
};

const SHIPPER_LEGS = ['shipper', 'mm_shipper', 'wh_shipper'];
const CARRIER_LEGS = ['carrier', 'mm_carrier', 'wh_carrier'];

const sumLegs = (order, perspectives) =>
    perspectives.reduce(
        (total, perspective) =>
            total +
            (calcSubtotalPerspective(order, perspective) || 0) +
            (calcAccessorialsPerspective(order, perspective) || 0),
        0
    );

// Header totals for the Rates tab. Core suppresses the carrier payable when shipper and carrier
// share an organization, so on those orders the carrier tile reads N/A (null) and the split is
// taken against the contractor instead — the same treatment the completed-orders table applies.
export const computeAggregate = (order) => {
    if (!order) return { shipper: null, carrier: null, contractor: null, splitPct: null };

    const selfBilled = isSelfBilled(order);
    const shipper = sumLegs(order, SHIPPER_LEGS);
    const carrier = selfBilled ? null : sumLegs(order, CARRIER_LEGS);
    const contractor = sumLegs(order, ['contractor']);
    const payable = selfBilled ? contractor : carrier;
    const splitPct = shipper > 0 ? (payable / shipper) * 100 : null;

    return { shipper, carrier, contractor, splitPct };
};
